export default __webpack_public_path__ + "static/media/sponsor-fig.5e690bb9.jpg";